import React, { useEffect, useState } from "react";
import NavLinks from "./NavLinks";
import CloseBtn from "../assets/images/shapes/close-1-1.png";
import onlineGovBadge from "../assets/images/online.png";

const MobileMenu = () => {
  const [hasMounted, setHasMounted] = useState(false);

  // Hàm đóng menu
  const closeMobileMenu = () => {
    document.querySelector(".side-menu__block").classList.remove("active");
  };

  useEffect(() => {
    const mobileMenu = () => {
      let toggler = document.querySelector(".side-menu__toggler");
      if (toggler) {
        toggler.addEventListener("click", function (e) {
          let block = document.querySelector(".side-menu__block");
          if (block) block.classList.toggle("active");
          e.preventDefault();
        });
      }

      // Đóng menu khi nhấn nút đóng hoặc overlay - Đã chuyển sang dùng onClick trực tiếp
    };

    if (typeof window !== "undefined") {
      mobileMenu();
      setHasMounted(true);
    }
  }, []);

  if (!hasMounted) {
    return null;
  }

  return (
    <div className="side-menu__block" >
      <div 
        className="side-menu__block-overlay custom-cursor__overlay" 
        onClick={closeMobileMenu}
        onKeyDown={(e) => { if (e.key === 'Enter') closeMobileMenu(); }}
        role="button"
        tabIndex={0}
      >
        <div className="cursor"></div>
        <div className="cursor-follower"></div>
      </div>
      <div className="side-menu__block-inner">
        <div className="side-menu__top justify-content-end">
          <a href="#none" className="side-menu__toggler side-menu__close-btn" onClick={(e) => { e.preventDefault(); closeMobileMenu(); }}>
            <img src={CloseBtn} alt="awesome post" />
          </a>
        </div>

        <nav className="mobile-nav__container">
          <NavLinks linkClass="menu-link" onLinkClick={closeMobileMenu} />
        </nav>
        <div className="side-menu__sep"></div>
        <div className="side-menu__content">
          <a href="https://zalo.me/s/335985251439518648" className="menu-link" style={{ display: 'block', marginBottom: '10px' }} onClick={closeMobileMenu}>
            <span>Tải ứng dụng</span>
          </a>
          <a href="https://www.noi.dating/" className="menu-link" style={{ display: 'block', marginBottom: '15px' }} onClick={closeMobileMenu}>
            <span>Nối Group</span>
          </a>

          {/* Government Badge */}
          <div style={{ textAlign: 'center', marginTop: '10px' }}>
            <a
              href="http://online.gov.vn/Home/AppDetails/3510"
              target="_blank"
              rel="noopener noreferrer"
              title="Đã đăng ký với Bộ Công Thương"
            >
              <img
                src={onlineGovBadge}
                alt="Đã đăng ký Bộ Công Thương"
                style={{
                  width: '120px',
                  height: 'auto',
                  cursor: 'pointer'
                }}
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;
